import React, { useEffect, useRef } from 'react';
import { useDashboard } from '../context/DashboardContext';

const Ticker = () => {
  const { tickerMessage, tickerWarning } = useDashboard();
  const tickerRef = useRef(null);

  useEffect(() => {
    const updatePosition = () => {
      const header = document.querySelector('header');
      
      if (tickerRef.current && header) {
        // Use getBoundingClientRect for accurate measurement
        const headerRect = header.getBoundingClientRect();
        const headerHeight = headerRect.height || header.offsetHeight || 70;
        
        // Position ticker flush with header bottom (no gap)
        // Set styles directly with !important to override CSS
        const element = tickerRef.current;
        element.style.setProperty('top', `${headerHeight}px`, 'important');
        element.style.setProperty('display', 'block', 'important');
        element.style.setProperty('visibility', 'visible', 'important');
        element.style.setProperty('opacity', '1', 'important');
        element.style.setProperty('position', 'fixed', 'important');
      }
    };

    // Update on mount and resize
    updatePosition();
    
    const timeouts = [
      setTimeout(updatePosition, 50),
      setTimeout(updatePosition, 100),
      setTimeout(updatePosition, 200),
      setTimeout(updatePosition, 500)
    ];
    
    window.addEventListener('resize', updatePosition);
    window.addEventListener('orientationchange', () => {
      setTimeout(updatePosition, 100);
    });
    
    // Use ResizeObserver to watch for header height changes
    let resizeObserver = null;
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(() => {
        updatePosition();
      });
      
      const header = document.querySelector('header');
      if (header) resizeObserver.observe(header);
    }

    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('orientationchange', updatePosition);
      timeouts.forEach(timeout => clearTimeout(timeout));
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, []);

  return (
    <div 
      ref={tickerRef}
      className={`ticker-wrap ${tickerWarning ? 'warning-mode' : ''}`}
      style={{
        display: 'block',
        visibility: 'visible',
        opacity: 1,
        position: 'fixed',
        zIndex: 999
      }}
    >
      <div className="ticker-content">
        {tickerMessage}
      </div>
    </div>
  );
};

export default Ticker;

